import { combineReducers } from './combineReducers';
import { appReducer } from './app.reducer';
import { RootState } from '../types';

export const initialState: RootState = {
  data: {
    projects: [],
    projectAttachments: [],
    alerts: [],
    alertAttachments: [],
    faqs: [],
    loading: true,
    menuEnabled: true,
    networkStatus: false,
  },
};

export const reducers = combineReducers({
  data: appReducer,
});
